<template>
  <Teleport to="body">
    <Transition name="toast">
      <div v-if="toasts.length" class="toaster__wrapper">
        <TransitionGroup name="toast" tag="ul">
          <li
            v-for="toast in toasts"
            :key="toast.id"
            :class="['toaster__inner', toastClassMap[toast.status]]"
          >
            <span class="toaster__inner-text">
              {{ toast.text }}
            </span>
          </li>
        </TransitionGroup>
      </div>
    </Transition>
  </Teleport>
</template>
<script setup lang="ts">
import { useToastStore, type TToastStatus } from "@/stores/toast";
import { storeToRefs } from "pinia";

const toastClassMap: Record<TToastStatus, string> = {
  warning: "warning",
  error: "error",
  success: "success",
};
const toastStore = useToastStore();
const { toasts } = storeToRefs(toastStore);
</script>
<style scoped lang="scss">
.toast-enter-from,
.toast-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.toast-enter-active,
.toast-leave-active {
  transition: 0.25s ease all;
}

.toaster {
  &__wrapper {
    position: fixed;
    bottom: 1%;
    right: 2%;

    z-index: 100;

    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__inner {
    --color: black;
    display: flex;
    align-items: center;
    gap: 1rem;
    &:not(:last-child) {
      margin-bottom: 0.4rem; // Add padding only if not the last element
    }
    border-radius: 0.3rem;

    border: 1px solid transparent;

    background-color: white;

    padding: 0.5rem 0.5rem;

    background-color: var(--color);
    color: white;

    svg {
      fill: white;
      stroke: white;
    }

    &.success {
      --color: var(--color-primary);
    }

    &.warning {
      --color: orange;
    }

    &.error {
      --color: var(--color-error);
    }

    &-text {
      font-size: 12px;
    }
  }
}
</style>
